// Client config. Prefer Vite env; keep current production fallbacks so a missing
// Vercel var does not blank the Mini App.

export const RECEIVER = (
  import.meta.env.VITE_PUBLIC_RECIPIENT ||
  '0x4402764E3c27186D848C3E847D1358552939a090'
) as `0x${string}`;

export const USDC_BASE = '0x833589fCD6EDb6E08f4c7C32D4f71b54bDA02913' as `0x${string}`;

export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  'https://voejxacjarwjbtwxmmnt.supabase.co';

export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZvZWp4YWNqYXJ3amJ0d3htbW50Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ5MjcxMzYsImV4cCI6MjA3MDUwMzEzNn0.BAM9bAb-cXpIYOZO6b0XrloSgdveBUpqrhIgYoiyAEw';

export const GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY ||
  'AIzaSyBHZt-mrBBaqZJNEmeK6S7Zm_LAZkYc2WE';

export const UNIT_ETH = 0.005;
export const UNIT_USDC = 15;

export const BASE_APP_CLIENT_FID = 309857;
